import { render, staticRenderFns } from "./puck.vue?vue&type=template&id=335b118c&scoped=true&"
import script from "./puck.vue?vue&type=script&lang=js&"
export * from "./puck.vue?vue&type=script&lang=js&"
import style0 from "./puck.vue?vue&type=style&index=0&id=335b118c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335b118c",
  null
  
)

export default component.exports